export class TravelTaskDto {
  origin: string;
  destiny: string;
  worksheetHasVehicleId?: string;
  km?: number;
}
